import React, { Component } from 'react';
import loader from 'assets/loader.svg';
import './Loader.scss';

class Loader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
    };
  }

  render() {
    return (
      <div>
        <div>{/* Blur container*/}</div>
        <div>
          <img src={loader} alt="Loading Spinner" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }
}

export default Loader;
